import { render, staticRenderFns } from "./createProrram.vue?vue&type=template&id=606086d4&scoped=true"
import script from "./createProrram.vue?vue&type=script&lang=js"
export * from "./createProrram.vue?vue&type=script&lang=js"
import style0 from "./createProrram.vue?vue&type=style&index=0&id=606086d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606086d4",
  null
  
)

export default component.exports